var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("修改个人信息"),
      "ok-text": _vm.$t("确定"),
      "cancel-text": _vm.$t("取消"),
      maskClosable: false,
      destroyOnClose: true,
      "confirm-loading": _vm.confirmLoading
    },
    on: {
      ok: _vm.confirmModal,
      cancel: _vm.cancelModal
    },
    model: {
      value: _vm.visibleModal,
      callback: function ($$v) {
        _vm.visibleModal = $$v;
      },
      expression: "visibleModal"
    }
  }, [_c("a-form-model", {
    ref: "editPersonInfoRef",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("管理员名称"),
      prop: "nickName"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("管理员名称"),
      disabled: _vm.diabledEditName,
      maxLength: 100
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("nickName");
      }
    },
    model: {
      value: _vm.form.nickName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nickName", $$v);
      },
      expression: "form.nickName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("账号"),
      prop: "account"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入账号"),
      maxLength: 50
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("account");
      }
    },
    model: {
      value: _vm.form.account,
      callback: function ($$v) {
        _vm.$set(_vm.form, "account", $$v);
      },
      expression: "form.account"
    }
  })], 1), _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "12px !important"
    },
    attrs: {
      label: _vm.$t("邮箱"),
      prop: "email"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入邮箱")
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("email");
      }
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c("p", {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t("用于接收系统通知，未填写邮箱可能无法正常接收")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };